import { resources } from './resources';

export const config = {
  rowsPerPage: [25, 50, 100],
  rowsPerPageStats: [7, 15, 30],
};

export const resourcesName = {
  walletGlobalStat: 'walletGlobalStat',
  walletGlobalStatPerAsset: 'walletGlobalStatPerAsset',
  transactionStat: 'transactionStat',
  transactionStatPerAsset: 'transactionStatPerAsset'
};

export const movementsTransactionStats = ['income', 'outcome', 'purchase', 'selling']

export const findByIdLinks = {
  transactionId: '/users/*/wallets/*/transactions/:transactionId',
  assetId: '/assets/:assetId',
  ratesId: '/assets/*/rates/:ratesId',
  rateId: '/assets/*/rates/:rateId', // necessary duplication because in asset the variable is called "rateId" while in other places its "ratesId"
  userId: '/users/:userId',
  walletId: '/users/*/wallets/:walletId',
  marketDataId: '/assets/*/market-data/:marketDataId',
  clientId: '/clients/:clientId',
  withdrawalId: '/users/*/wallets/*/withdrawals/:withdrawalId',
  purchaseId: '/users/*/wallets/*/purchases/:purchaseId',
  otcOrderId: '/users/*/wallets/*/trade/otc-order/:otcOrderId',
};

export const resourcesNavigationGroups = [
  {
    name: 'Frontoffice Access',
    resources: [resources.client],
  },
  {
    name: 'Users & wallets',
    resources: [resources.user, resources.wallet],
  },
  {
    name: 'Transactions',
    resources: [
      resources.transaction,
      resources.withdrawal,
      resources.purchase,
      resources.otcOrder
    ],
  },
  {
    name: 'Assets',
    resources: [resources.asset, resources.rate, resources.marketData],
  },
  {
    name: 'Statistics',
    resources: [
      resources.userStat,
      resources.walletStat,
      resources.walletGlobalStat,
      resources.walletGlobalStatPerAsset,
      resources.transactionStat,
      resources.transactionStatPerAsset,
      resources.purchaseStat,
    ],
  },
];